import React, { useEffect } from "react";

interface Props {
  href: string;
}

// eslint-disable-next-line import/prefer-default-export
export const RedirectPage: React.FC<Props> = ({ href }) => {
  useEffect(() => {
    if (href) {
      window.location.replace(href);
    }
  }, [href]);
  return <div />;
};
